import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

<meta name="viewport" content="width=device-width, initial-scale=1"></meta>;
ReactDOM.render(<App />, document.getElementById("root"));
